// Lógica de reservas, mapa de asientos, pasarela de pago y boletas QR
// js/booking.js

// Estado de la reservación
let currentShowId = 0;
let currentShowTitle = "";
let currentShowtimeId = 0;
let showtimesList = [];
let selectedSeats = [];
let generalQty = 1;
let currentShowtimeData = null;
let bookingTimer = null;
let bookingTimerDuration = 600; // Valor dinámico desde backend
let bookingLimit = 8; // Límite dinámico de boletas por compra desde backend
let currentCompraId = "";
let appliedDiscount = null;
let donacionEsAnonima = false;

// Helper: Cargar dinámicamente Bold Checkout para mejorar el LCP y el bloqueo del hilo principal
async function ensureBoldCheckoutLoaded() {
    if (typeof BoldCheckout !== 'undefined') return true;
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = "https://checkout.bold.co/library/boldPaymentButton.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.head.appendChild(script);
    });
}

// Tarifas fijas de las zonas del teatro (si no las define el backend)
const ZONAS_PRECIOS = {
    general: 15000,
    gris: 20000,
    amarillo: 30000,
    azul: 40000
};

// 1. Iniciar Reservación
async function iniciarReserva(showId, showTitle) {
    currentShowId = showId;
    currentShowTitle = showTitle;
    selectedSeats = [];
    generalQty = 1;
    currentShowtimeId = 0;
    currentShowtimeData = null;
    clearInterval(bookingTimer);

    // Resetear formulario
    document.getElementById("buyerName").value = "";
    document.getElementById("buyerEmail").value = "";
    document.getElementById("buyerPhone").value = "";

    // Ocultar botones del modal
    document.getElementById("btnBackStep").style.display = "none";
    document.getElementById("btnPay").style.display = "none";
    document.getElementById("lockTimer").style.display = "none";
    document.getElementById("footerTotalPrice").innerText = "$0 COP";

    // Mostrar Paso 1
    document.getElementById("bookingStepInfo").style.display = "block";
    document.getElementById("bookingStepSelection").style.display = "none";
    document.getElementById("bookingModalTitle").innerText = `Comprar: ${showTitle}`;

    // Mostrar Modal
    document.getElementById("bookingModal").classList.add("active");
    updateStepper(1);

    // Buscar las funciones disponibles
    await cargarFunciones(showId);
}

function closeBookingModal() {
    document.getElementById("bookingModal").classList.remove("active");
    clearInterval(bookingTimer);
    quitarCodigoDescuento();
    // Liberar asientos si hay una compra pendiente sin pagar
    if (currentCompraId && selectedSeats.length > 0) {
        liberarAsientosExpirados();
    }
}

// Cargar funciones asociadas a la obra
async function cargarFunciones(showId) {
    const selectionStepDiv = document.getElementById("bookingStepSelection");

    // Eliminar select de showtimes previo si existe
    const oldSelect = document.getElementById("showtimeSelectorContainer");
    if (oldSelect) oldSelect.remove();

    try {
        const response = await fetch(`api/showtimes.php?obra_id=${showId}`);
        const result = await response.json();

        if (result.config) {
            if (result.config.limite_boletas) bookingLimit = parseInt(result.config.limite_boletas);
            if (result.config.tiempo_bloqueo_minutos) bookingTimerDuration = parseInt(result.config.tiempo_bloqueo_minutos) * 60;
        }

        if (result.success && result.data.length > 0) {
            showtimesList = result.data;
        } else {
            showtimesList = generarFuncionesMock(showId);
        }
    } catch (error) {
        console.warn("Error al cargar funciones desde API, usando mock local:", error);
        showtimesList = generarFuncionesMock(showId);
    }

    // Crear selector de funciones
    let selectHTML = `
        <div class="form-group" id="showtimeSelectorContainer" style="margin-bottom: 1.5rem;">
            <label class="form-label">Selecciona la Función (Fecha, Hora y Lugar)</label>
            <select id="showtimeSelect" class="form-input" onchange="seleccionarFuncion(this.value)">
                <option value="">-- Seleccionar función --</option>
    `;

    showtimesList.forEach((fun, index) => {
        const fecha = new Date(fun.fecha_hora).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        selectHTML += `<option value="${fun.id}">${fecha} - ${fun.lugar}</option>`;
    });

    selectHTML += `</select></div>`;

    // Insertar el selector al inicio del paso de selección
    selectionStepDiv.insertAdjacentHTML('afterbegin', selectHTML);
}

// Generar funciones Mock si no hay BD
function generarFuncionesMock(showId) {
    // Si la obra es par, la hacemos numerada en el Teatro Guillermo Valencia. Si es impar, general.
    const esNumerada = showId % 2 === 1;
    return [
        {
            id: showId * 100 + 1,
            obra_id: showId,
            fecha_hora: new Date(Date.now() + 86400000).toISOString(), // Mañana
            lugar: esNumerada ? "Teatro Guillermo Valencia" : "Parque Caldas (Aire Libre)",
            distribucion: esNumerada ? "numerada" : "general",
            precio_general: 15000,
            precio_gris: 20000,
            precio_amarillo: 30000,
            precio_azul: 40000,
            capacidad_total: esNumerada ? 350 : 200
        },
        {
            id: showId * 100 + 2,
            obra_id: showId,
            fecha_hora: new Date(Date.now() + 172800000).toISOString(), // Pasado mañana
            lugar: "Auditorio Alcaldía de Popayán",
            distribucion: "general",
            precio_general: 10000,
            precio_gris: 0,
            precio_amarillo: 0,
            precio_azul: 0,
            capacidad_total: 120
        }
    ];
}

// 2. Paso 1 a Paso 2
function nextBookingStep() {
    const name = document.getElementById("buyerName").value.trim();
    const email = document.getElementById("buyerEmail").value.trim();

    if (name === "" || email === "") {
        alert("Por favor ingrese su nombre y correo electrónico para continuar.");
        return;
    }

    document.getElementById("bookingStepInfo").style.display = "none";
    document.getElementById("bookingStepSelection").style.display = "block";

    document.getElementById("btnBackStep").style.display = "inline-block";
    document.getElementById("btnPay").style.display = "inline-block";
    
    updateStepper(2);

    // Seleccionar automáticamente la primera opción si solo hay una
    const select = document.getElementById("showtimeSelect");
    if (select && select.options.length === 2) {
        select.selectedIndex = 1;
        seleccionarFuncion(select.value);
    }
}

function prevBookingStep() {
    document.getElementById("bookingStepInfo").style.display = "block";
    document.getElementById("bookingStepSelection").style.display = "none";

    document.getElementById("btnBackStep").style.display = "none";
    document.getElementById("btnPay").style.display = "none";
    document.getElementById("lockTimer").style.display = "none";
    clearInterval(bookingTimer);
    
    updateStepper(1);
}

function updateStepper(step) {
    const s1 = document.getElementById("stepIndicator1");
    const s2 = document.getElementById("stepIndicator2");
    const s3 = document.getElementById("stepIndicator3");
    if (s1) s1.classList.remove("step-active");
    if (s2) s2.classList.remove("step-active");
    if (s3) s3.classList.remove("step-active");
    
    if (step >= 1 && s1) s1.classList.add("step-active");
    if (step >= 2 && s2) s2.classList.add("step-active");
    if (step >= 3 && s3) s3.classList.add("step-active");
}

// Seleccionar Función específica
async function seleccionarFuncion(funcionId) {
    currentShowtimeId = parseInt(funcionId);
    selectedSeats = [];
    generalQty = 1;

    document.getElementById("footerTotalPrice").innerText = "$0 COP";
    document.getElementById("selectedSeatsList").innerText = "Ninguno";
    document.getElementById("generalQtyLabel").innerText = "1";

    if (!funcionId) {
        document.getElementById("selectionGeneral").style.display = "none";
        document.getElementById("selectionNumerada").style.display = "none";
        return;
    }

    // Buscar datos de la función
    currentShowtimeData = showtimesList.find(f => f.id === currentShowtimeId);

    if (!currentShowtimeData) return;

    // Obtener detalle actualizado desde la API incluyendo plano y mapa_config de la sede
    try {
        const detailRes = await fetch(`api/showtimes.php?funcion_id=${currentShowtimeId}&_t=${Date.now()}`);
        const detailResult = await detailRes.json();
        if (detailResult.success && detailResult.data) {
            currentShowtimeData = { ...currentShowtimeData, ...detailResult.data };
        }
    } catch(e) {}

    if (currentShowtimeData.distribucion === 'general') {
        document.getElementById("selectionGeneral").style.display = "block";
        document.getElementById("selectionNumerada").style.display = "none";
        document.getElementById("generalPriceLabel").innerText = `$${currentShowtimeData.precio_general.toLocaleString('es-CO')} COP`;
        calcularTotal();
    } else {
        document.getElementById("selectionGeneral").style.display = "none";
        document.getElementById("selectionNumerada").style.display = "block";

    // Cargar asientos ocupados y datos actualizados de la sede desde la API
        let ocupados = [];
        try {
            const res = await fetch(`api/showtimes.php?funcion_id=${currentShowtimeId}&_t=${Date.now()}`);
            const result = await res.json();
            if (result.config) {
                if (result.config.limite_boletas) bookingLimit = parseInt(result.config.limite_boletas);
                if (result.config.tiempo_bloqueo_minutos) bookingTimerDuration = parseInt(result.config.tiempo_bloqueo_minutos) * 60;
            }
            if (result.success && result.data) {
                // Mezclar la información de la sede (plano_imagen_url, mapa_config) devuelta por la API
                currentShowtimeData = { ...currentShowtimeData, ...result.data };
                ocupados = result.data.asientos_ocupados || [];

                // Redibujar inmediatamente el mapa con los datos de la sede actualizados
                dibujarMapaTeatro(ocupados);

                // Renderizar disponibilidad por sección
                const breakdownDiv = document.getElementById("sectionAvailabilityBreakdown");
                if (breakdownDiv && result.data.capacidad_secciones) {
                    const secs = result.data.capacidad_secciones;
                    breakdownDiv.innerHTML = `
                        <span style="color:var(--text-muted); margin-right:8px;">Disponibles:</span>
                        <span style="color:var(--text-light); margin-right:15px;"><i class="fa-solid fa-circle" style="font-size:0.7rem; color:var(--seat-grey);"></i> Platea: <strong>${secs.gris.disponibles}/${secs.gris.total}</strong></span>
                        <span style="color:var(--text-light); margin-right:15px;"><i class="fa-solid fa-circle" style="font-size:0.7rem; color:var(--seat-yellow);"></i> Palcos G1: <strong>${secs.amarillo.disponibles}/${secs.amarillo.total}</strong></span>
                        <span style="color:var(--text-light);"><i class="fa-solid fa-circle" style="font-size:0.7rem; color:var(--seat-blue);"></i> Palcos G2: <strong>${secs.azul.disponibles}/${secs.azul.total}</strong></span>
                    `;
                }
            }
        } catch (error) {
            console.warn("No se pudo consultar asientos ocupados:", error);
        }

        dibujarMapaTeatro(ocupados);
        calcularTotal();
    }
}

// 3. Dibujar Mapa del Teatro / Sede (Plano Personalizado o Algoritmo Fallback)
function dibujarMapaTeatro(ocupados = []) {
    const svgContainer = document.getElementById("svgContainer");
    if (!svgContainer) return;

    // Verificar si la sede actual tiene plano en imagen y lista de coordenadas
    let mapaConfig = null;
    let planoImg = null;

    if (currentShowtimeData) {
        if (currentShowtimeData.mapa_config) {
            let rawConfig = currentShowtimeData.mapa_config;
            if (typeof rawConfig === 'string') {
                try {
                    mapaConfig = JSON.parse(rawConfig);
                    // Si viene doblemente serializado como string JSON
                    if (typeof mapaConfig === 'string') {
                        mapaConfig = JSON.parse(mapaConfig);
                    }
                } catch(e) {
                    console.warn("Error parseando mapa_config:", e);
                }
            } else if (Array.isArray(rawConfig)) {
                mapaConfig = rawConfig;
            }
        }
        if (currentShowtimeData.plano_imagen_url) {
            planoImg = currentShowtimeData.plano_imagen_url;
        }
    }

    // Si existen asientos mapeados en coordenadas porcentuales por el administrador
    if (Array.isArray(mapaConfig) && mapaConfig.length > 0) {
        let canvasHTML = `<div class="panzoom-element" style="position:relative; width:100%; max-width:700px; margin:0 auto; overflow:hidden; border-radius:12px; border:1px solid var(--border-card); background:rgba(0,0,0,0.4);">`;
        
        if (planoImg) {
            canvasHTML += `<img src="${planoImg}" style="width:100%; display:block; opacity:0.85;" loading="lazy">`;
        } else {
            canvasHTML += `<div style="width:100%; height:380px; background:rgba(0,0,0,0.5);"></div>`;
        }

        canvasHTML += `<div style="position:absolute; top:0; left:0; width:100%; height:100%;">`;

        mapaConfig.forEach(a => {
            const asientoId = `${a.sector === 'gris' ? 'Gris' : (a.sector === 'amarillo' ? 'Amarillo' : 'Azul')}_${a.id}`;
            const estaOcupado = ocupados.includes(asientoId);
            const estaSeleccionado = selectedSeats.includes(asientoId);
            const tamPx = a.size || 14;

            let claseColor = 'gris';
            if (a.sector === 'amarillo') claseColor = 'amarillo';
            if (a.sector === 'azul') claseColor = 'azul';

            canvasHTML += `
                <div class="seat-node ${claseColor} ${estaOcupado ? 'bloqueado' : ''} ${estaSeleccionado ? 'seleccionado' : ''}"
                     style="position:absolute; left:${a.x}%; top:${a.y}%; width:${tamPx}px; height:${tamPx}px; border-radius:50%; transform:translate(-50%, -50%); cursor:${estaOcupado ? 'not-allowed' : 'pointer'}; border:1px solid rgba(255,255,255,0.8); box-shadow:0 0 5px rgba(0,0,0,0.5);"
                     data-asiento="${asientoId}"
                     title="Ubicación ${a.sector.toUpperCase()} - ${a.id}">
                </div>
            `;
        });

        canvasHTML += `</div></div>`;
        svgContainer.innerHTML = canvasHTML;
        
        initPanzoomAndDelegation(svgContainer, svgContainer.querySelector('.panzoom-element'));
        return;
    }

    // Fallback: Si no hay plano personalizado creado, usar el generador paramétrico
    let svgHTML = `
        <svg class="panzoom-element" viewBox="0 0 800 450" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    `;
    const centroX = 400;
    const centroY = 30;

    for (let f = 0; f < 10; f++) {
        const radio = 120 + (f * 20);
        const numAsientos = 8 + (f * 2);
        for (let a = 0; a < numAsientos; a++) {
            const angulo = 45 + (a * 90 / (numAsientos - 1));
            const rad = angulo * Math.PI / 180;
            const x = centroX + (radio * Math.cos(rad));
            const y = centroY + (radio * Math.sin(rad));
            const asientoId = `Gris_C${f + 1}-${a + 1}`;
            const estaOcupado = ocupados.includes(asientoId);

            svgHTML += `
                <circle cx="${x}" cy="${y}" r="6" 
                    class="seat-node gris ${estaOcupado ? 'bloqueado' : ''}" 
                    data-asiento="${asientoId}" 
                    title="Platea C${f + 1}-${a + 1}"
                />
            `;
        }
    }
    svgHTML += `</svg>`;
    svgContainer.innerHTML = svgHTML;
    
    initPanzoomAndDelegation(svgContainer, svgContainer.querySelector('.panzoom-element'));
}

// Inicializar Panzoom con Throttling RAF y Delegación de Eventos
let isSeatDelegationBound = false;
let rafSliderId = null;

function initPanzoomAndDelegation(container, pzElem) {
    if (!isSeatDelegationBound && container) {
        container.addEventListener('click', (e) => {
            const target = e.target.closest('.seat-node');
            if (target) {
                toggleAsiento(target);
            }
        });
        isSeatDelegationBound = true;
    }

    if (typeof Panzoom !== 'undefined' && pzElem) {
        const pz = Panzoom(pzElem, { maxScale: 4, minScale: 0.8, contain: 'outside' });
        const slider = document.getElementById('zoomSlider');
        if (slider) {
            slider.value = 1;
            slider.oninput = (e) => {
                const val = Number(e.target.value);
                if (rafSliderId) cancelAnimationFrame(rafSliderId);
                rafSliderId = requestAnimationFrame(() => {
                    pz.zoom(val);
                });
            };
            pzElem.addEventListener('panzoomzoom', (e) => {
                if (rafSliderId) cancelAnimationFrame(rafSliderId);
                rafSliderId = requestAnimationFrame(() => {
                    slider.value = e.detail.scale;
                });
            });
        }
    }
}

// Seleccionar/Deseleccionar Asiento
function toggleAsiento(element) {
    if (element.classList.contains("bloqueado")) return;

    const asientoId = element.getAttribute("data-asiento");
    const index = selectedSeats.indexOf(asientoId);

    if (index > -1) {
        // Remover de la selección
        selectedSeats.splice(index, 1);
        element.classList.remove("seleccionado");
    } else {
        // Validar límite dinámico de boletas por compra
        if (selectedSeats.length >= bookingLimit) {
            alert(`El límite máximo de boletas por compra es de ${bookingLimit} personas.`);
            return;
        }
        // Agregar a la selección
        selectedSeats.push(asientoId);
        element.classList.add("seleccionado");
    }

    // Actualizar vista
    actualizarAsientosSeleccionadosList();
    calcularTotal();
}

function actualizarAsientosSeleccionadosList() {
    const listSpan = document.getElementById("selectedSeatsList");
    if (selectedSeats.length === 0) {
        listSpan.innerText = "Ninguno";
    } else {
        // Limpiar nombres técnicos de zonas para el cliente
        const limpios = selectedSeats.map(s => {
            const partes = s.split('_');
            return partes[1]; // Retorna ej: "C1-5" o "L1-3"
        });
        listSpan.innerText = limpios.join(", ");
    }
}

// 4. Modificar cantidad general (+/-)
function updateGeneralQty(change) {
    let newQty = generalQty + change;
    if (newQty < 1) newQty = 1;
    if (newQty > bookingLimit) {
        alert(`El límite máximo de boletas por compra es de ${bookingLimit} personas.`);
        newQty = bookingLimit;
    }
    generalQty = newQty;
    document.getElementById("generalQtyLabel").innerText = generalQty;
    calcularTotal();
}

// 5. Calcular Total a pagar
function calcularTotal() {
    let rawTotal = 0;
    if (!currentShowtimeData) return;

    const currentTicketsCount = (currentShowtimeData.distribucion === 'general') ? generalQty : selectedSeats.length;

    if (currentShowtimeData.distribucion === 'general') {
        const precio = parseFloat(currentShowtimeData.precio_general) || ZONAS_PRECIOS.general;
        rawTotal = precio * generalQty;
    } else {
        selectedSeats.forEach(asiento => {
            let precio = parseFloat(currentShowtimeData.precio_general) || ZONAS_PRECIOS.general;

            if (asiento.startsWith("Gris_")) {
                precio = parseFloat(currentShowtimeData.precio_gris) || ZONAS_PRECIOS.gris;
            } else if (asiento.startsWith("Amarillo_")) {
                precio = parseFloat(currentShowtimeData.precio_amarillo) || ZONAS_PRECIOS.amarillo;
            } else if (asiento.startsWith("Azul_")) {
                precio = parseFloat(currentShowtimeData.precio_azul) || ZONAS_PRECIOS.azul;
            }

            rawTotal += precio;
        });
    }

    let isPromoValid = true;
    let promoWarning = "";

    if (appliedDiscount && appliedDiscount.cantidad_boletas) {
        const reqQty = parseInt(appliedDiscount.cantidad_boletas);
        if (currentTicketsCount !== reqQty) {
            isPromoValid = false;
            promoWarning = `El cupón ${appliedDiscount.codigo} (25% OFF) requiere exactamente ${reqQty} boletas (tienes ${currentTicketsCount} seleccionada${currentTicketsCount === 1 ? '' : 's'}).`;
        }
    }

    let finalTotal = rawTotal;
    if (appliedDiscount && isPromoValid && rawTotal > 0) {
        let discountAmount = 0;
        if (appliedDiscount.tipo === 'porcentaje') {
            discountAmount = Math.round((rawTotal * parseFloat(appliedDiscount.valor)) / 100);
        } else {
            discountAmount = Math.min(rawTotal, parseFloat(appliedDiscount.valor));
        }
        finalTotal = Math.max(0, rawTotal - discountAmount);

        const totalLabel = document.getElementById("footerTotalLabel");
        if (totalLabel) {
            totalLabel.innerHTML = `
                <span style="font-size: 0.85rem; color: var(--text-muted); display: block;">
                    Subtotal (${currentTicketsCount} boletas): $${rawTotal.toLocaleString('es-CO')} COP 
                    <strong style="color: #2ecc71; margin-left: 6px;"><i class="fa-solid fa-tag"></i> - $${discountAmount.toLocaleString('es-CO')} COP (${appliedDiscount.valor}%)</strong>
                </span>
                <span style="font-size: 0.95rem; color: var(--text-light); display: block;">Total con Descuento:</span>
            `;
        }
        document.getElementById("footerTotalPrice").innerText = `$${finalTotal.toLocaleString('es-CO')} COP`;

        const feedback = document.getElementById("discountFeedback");
        if (feedback && feedback.style.display !== 'none') {
            feedback.style.color = '#2ecc71';
            const descText = appliedDiscount.tipo === 'porcentaje' ? `${appliedDiscount.valor}%` : `$${parseFloat(appliedDiscount.valor).toLocaleString('es-CO')} COP`;
            feedback.innerHTML = `<i class="fa-solid fa-circle-check"></i> ¡Código <strong>${appliedDiscount.codigo}</strong> aplicado! (${descText} de descuento en tus ${appliedDiscount.cantidad_boletas || currentTicketsCount} boletas)`;
        }
    } else if (appliedDiscount && !isPromoValid && rawTotal > 0) {
        const totalLabel = document.getElementById("footerTotalLabel");
        if (totalLabel) {
            totalLabel.innerHTML = `
                <span style="font-size: 0.8rem; color: #f59e0b; display: block;">
                    <i class="fa-solid fa-triangle-exclamation"></i> ${promoWarning}
                </span>
                <span style="font-size: 0.95rem; color: var(--text-light); display: block;">Total a pagar:</span>
            `;
        }
        document.getElementById("footerTotalPrice").innerText = `$${rawTotal.toLocaleString('es-CO')} COP`;

        const feedback = document.getElementById("discountFeedback");
        if (feedback && feedback.style.display !== 'none') {
            feedback.style.color = '#f59e0b';
            feedback.innerHTML = `<i class="fa-solid fa-triangle-exclamation"></i> ${promoWarning}`;
        }
    } else {
        const totalLabel = document.getElementById("footerTotalLabel");
        if (totalLabel) totalLabel.innerText = "Total a pagar:";
        document.getElementById("footerTotalPrice").innerText = `$${rawTotal.toLocaleString('es-CO')} COP`;
    }
}

// Control del panel y validación de códigos de descuento
function toggleDiscountBox() {
    const box = document.getElementById("discountBoxContainer");
    if (!box) return;
    const isHidden = box.style.display === 'none' || !box.style.display;
    box.style.display = isHidden ? 'block' : 'none';
    if (isHidden) {
        const input = document.getElementById("inputDiscountCode");
        if (input) input.focus();
    }
}

async function aplicarCodigoDescuento() {
    const input = document.getElementById("inputDiscountCode");
    const feedback = document.getElementById("discountFeedback");
    const btnRemove = document.getElementById("btnRemoveDiscount");
    if (!input || !feedback) return;

    const code = input.value.trim().toUpperCase();
    if (!code) {
        feedback.style.display = 'block';
        feedback.style.color = '#ef4444';
        feedback.innerText = 'Por favor ingresa un código de descuento.';
        return;
    }

    const currentTicketsCount = (currentShowtimeData && currentShowtimeData.distribucion === 'general') ? generalQty : selectedSeats.length;

    try {
        feedback.style.display = 'block';
        feedback.style.color = 'var(--text-muted)';
        feedback.innerText = 'Validando código...';

        const response = await fetch(`api/booking.php?action=validate_coupon&codigo=${encodeURIComponent(code)}&cantidad=${currentTicketsCount}&_t=${Date.now()}`);
        const result = await response.json();

        if (result.success && result.data) {
            appliedDiscount = result.data;
            feedback.style.color = '#2ecc71';
            const descText = appliedDiscount.tipo === 'porcentaje' ? `${appliedDiscount.valor}%` : `$${parseFloat(appliedDiscount.valor).toLocaleString('es-CO')} COP`;
            
            if (appliedDiscount.cantidad_boletas && currentTicketsCount !== parseInt(appliedDiscount.cantidad_boletas)) {
                feedback.style.color = '#f59e0b';
                feedback.innerHTML = `<i class="fa-solid fa-circle-exclamation"></i> Código <strong>${appliedDiscount.codigo}</strong> activado: Selecciona exactamente ${appliedDiscount.cantidad_boletas} boletas para obtener el ${descText} de descuento (actualmente tienes ${currentTicketsCount}).`;
            } else {
                feedback.innerHTML = `<i class="fa-solid fa-circle-check"></i> ¡Código <strong>${appliedDiscount.codigo}</strong> aplicado! (${descText} de descuento)`;
            }

            if (btnRemove) btnRemove.style.display = 'inline-block';
            input.disabled = true;
            calcularTotal();
        } else {
            feedback.style.color = '#ef4444';
            feedback.innerHTML = `<i class="fa-solid fa-circle-xmark"></i> ${result.message || 'Código de descuento inválido o expirado.'}`;
        }
    } catch (error) {
        // Fallback para pruebas locales si backend no responde
        if (['PROMO4', 'COMBO25', 'FAMILIAR4', 'PROMO25'].includes(code)) {
            appliedDiscount = { codigo: code, tipo: 'porcentaje', valor: 25, cantidad_boletas: 4 };
            if (currentTicketsCount === 4) {
                feedback.style.color = '#2ecc71';
                feedback.innerHTML = `<i class="fa-solid fa-circle-check"></i> ¡Código <strong>${code}</strong> aplicado (Demostración)! (25% de descuento en tus 4 boletas)`;
            } else {
                feedback.style.color = '#f59e0b';
                feedback.innerHTML = `<i class="fa-solid fa-circle-exclamation"></i> Código <strong>${code}</strong> activado: Selecciona exactamente 4 boletas para obtener el 25% de descuento (tienes ${currentTicketsCount}).`;
            }
            if (btnRemove) btnRemove.style.display = 'inline-block';
            input.disabled = true;
            calcularTotal();
        } else if (code === 'FESTIVAL10' || code === 'PROMO10') {
            appliedDiscount = { codigo: code, tipo: 'porcentaje', valor: 10, cantidad_boletas: null };
            feedback.style.color = '#2ecc71';
            feedback.innerHTML = `<i class="fa-solid fa-circle-check"></i> ¡Código <strong>${code}</strong> aplicado (Demostración)! (10% de descuento)`;
            if (btnRemove) btnRemove.style.display = 'inline-block';
            input.disabled = true;
            calcularTotal();
        } else {
            feedback.style.color = '#ef4444';
            feedback.innerText = 'Error al validar el código o no existe.';
        }
    }
}

function quitarCodigoDescuento() {
    appliedDiscount = null;
    const input = document.getElementById("inputDiscountCode");
    const feedback = document.getElementById("discountFeedback");
    const btnRemove = document.getElementById("btnRemoveDiscount");
    if (input) {
        input.value = '';
        input.disabled = false;
    }
    if (feedback) {
        feedback.style.display = 'none';
        feedback.innerText = '';
    }
    if (btnRemove) btnRemove.style.display = 'none';
    calcularTotal();
}

// 6. Iniciar cuenta regresiva para el bloqueo de 10 minutos
function iniciarTemporizadorBloqueo(duracionSegundos) {
    clearInterval(bookingTimer);
    const timerDiv = document.getElementById("lockTimer");
    const countSpan = document.getElementById("timerCountdown");

    timerDiv.style.display = "flex";
    let tiempoRestante = duracionSegundos;

    bookingTimer = setInterval(() => {
        const minutos = Math.floor(tiempoRestante / 60);
        const segundos = tiempoRestante % 60;

        countSpan.innerText = `${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;

        if (tiempoRestante <= 0) {
            clearInterval(bookingTimer);
            alert("El tiempo reservado para tus boletas ha expirado. Los asientos se han liberado automáticamente.");
            liberarAsientosExpirados();
            closeBookingModal();
        }
        tiempoRestante--;
    }, 1000);
}

// Liberar bloqueos expirados en el backend
async function liberarAsientosExpirados() {
    if (!currentCompraId) return;
    try {
        // Enviar simulación de pago fallida al webhook local para liberar asientos
        await fetch('api/bold-webhook.php?simulate=true', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                simulate: true,
                compra_id: currentCompraId,
                estado: 'fallida',
                bold_ref: 'TIMEOUT-LIBERADO'
            })
        });
        currentCompraId = "";
    } catch (e) {
        console.error("Error liberando asientos expirados:", e);
    }
}

// 7. Procesar Pago y abrir Bold Checkout
async function processPayment() {
    if (!currentShowtimeId || !currentShowtimeData) {
        alert("Debe seleccionar una función válida.");
        return;
    }

    const currentTicketsCount = (currentShowtimeData.distribucion === 'general') ? generalQty : selectedSeats.length;

    if (currentShowtimeData.distribucion === 'numerada' && selectedSeats.length === 0) {
        alert("Debe seleccionar al menos un asiento.");
        return;
    }

    if (appliedDiscount && appliedDiscount.cantidad_boletas && currentTicketsCount !== parseInt(appliedDiscount.cantidad_boletas)) {
        alert(`El cupón ${appliedDiscount.codigo} (25% OFF) es válido únicamente para compras de exactamente ${appliedDiscount.cantidad_boletas} boletas. Por favor ajusta tu selección o retira el cupón.`);
        return;
    }

    const name = document.getElementById("buyerName").value.trim();
    const email = document.getElementById("buyerEmail").value.trim();
    const phone = document.getElementById("buyerPhone").value.trim();

    const requestData = {
        funcion_id: currentShowtimeId,
        comprador_nombre: name,
        comprador_email: email,
        comprador_telefono: phone,
        asientos: selectedSeats,
        cantidad: generalQty,
        es_anonimo: 0,
        codigo_descuento: appliedDiscount ? appliedDiscount.codigo : null
    };

    try {
        // Crear la orden y bloquear los asientos temporalmente en PHP/MySQL
        const response = await fetch('api/booking.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        });

        const result = await response.json();

        if (result.success) {
            currentCompraId = result.compra_id;

            // Iniciar cronómetro dinámico (bloqueo temporal en base de datos)
            if (currentShowtimeData.distribucion === 'numerada') {
                iniciarTemporizadorBloqueo(result.tiempo_limite_segundos || bookingTimerDuration);
            }
            
            updateStepper(3);

            // Si la pasarela oficial BoldCheckout está disponible, usarla
            await ensureBoldCheckoutLoaded();
            if (typeof BoldCheckout !== 'undefined') {
                const checkout = new BoldCheckout({
                    apiKey: result.apiKey,
                    amount: String(result.total),
                    orderId: result.compra_id,
                    currency: 'COP',
                    integritySignature: result.signature,
                    description: `Entradas: ${currentShowTitle}`,
                    tax: 0,
                    taxBase: 0,
                    redirectionUrl: `${window.location.origin}${window.location.pathname.replace('index.html', '')}confirmacion.html?compra_id=${result.compra_id}`
                });
                checkout.open();
            } else {
                // Cargar datos en el modal simulador de Bold
                document.getElementById("mockBuyerName").innerText = name;
                document.getElementById("mockReference").innerText = result.compra_id;
                document.getElementById("mockTotalAmount").innerText = `$${result.total.toLocaleString('es-CO')} COP`;

                // Abrir simulador de pasarela Bold para pruebas
                openBoldMockModal();
            }

        } else {
            alert(`Error: ${result.message}`);
        }

    } catch (error) {
        console.error("Error al procesar reserva:", error);
        // Fallback local autónomo para demostración visual si no hay backend activo
        alert("Error de conexión con el servidor. Iniciando simulación de checkout local sin base de datos.");
        currentCompraId = 'MOCK-' + Math.random().toString(36).substr(2, 9).toUpperCase();
        document.getElementById("mockBuyerName").innerText = name;
        document.getElementById("mockReference").innerText = currentCompraId;
        const totalSimulado = currentShowtimeData.distribucion === 'general' ?
            currentShowtimeData.precio_general * generalQty : ZONAS_PRECIOS.gris * selectedSeats.length;
        document.getElementById("mockTotalAmount").innerText = `$${totalSimulado.toLocaleString('es-CO')} COP`;
        openBoldMockModal();
    }
}

// 8. Control del Modal de Simulación Bold
function openBoldMockModal() {
    document.getElementById("boldMockModal").classList.add("active");
}

function closeBoldMockModal() {
    document.getElementById("boldMockModal").classList.remove("active");
}

// Enviar respuesta simulada al webhook de Bold
async function simulateWebhookResponse(estado) {
    closeBoldMockModal();

    try {
        const response = await fetch('api/bold-webhook.php?simulate=true', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                simulate: true,
                compra_id: currentCompraId,
                estado: estado, // aprobada, fallida
                bold_ref: 'SIM-PAY-' + Math.floor(Math.random() * 900000 + 100000)
            })
        });

        const result = await response.json();

        if (result.success && estado === 'aprobada') {
            clearInterval(bookingTimer); // Detener el temporizador de bloqueo
            closeBookingModal();
            window.location.href = `confirmacion.html?compra_id=${currentCompraId}`;
        } else {
            alert(estado === 'aprobada' ? "Pago aprobado pero falló la generación de boletas." : "El pago ha sido rechazado. Los asientos han sido liberados.");
            clearInterval(bookingTimer);
            closeBookingModal();
        }
    } catch (e) {
        console.warn("Backend no disponible para simulación de webhook, cargando tickets en confirmación local:", e);
        clearInterval(bookingTimer);
        closeBookingModal();
        window.location.href = `confirmacion.html?compra_id=${currentCompraId}&mock_buyer=${encodeURIComponent(document.getElementById("buyerName").value.trim())}&mock_show=${encodeURIComponent(currentShowTitle)}&mock_qty=${generalQty}&mock_seats=${encodeURIComponent(selectedSeats.join(','))}&mock_showtime=${encodeURIComponent(currentShowtimeData ? currentShowtimeData.fecha_hora : new Date().toISOString())}&mock_venue=${encodeURIComponent(currentShowtimeData ? currentShowtimeData.lugar : 'Teatro Guillermo Valencia')}`;
    }
}

// 9. Mostrar Boletas Confirmadas y Generar QR
async function mostrarBoletasConfirmadas(compraId) {
    const successModal = document.getElementById("successModal");
    const container = document.getElementById("generatedTicketsContainer");
    container.innerHTML = '';

    try {
        const response = await fetch(`api/booking.php?compra_id=${compraId}`);
        const result = await response.json();

        if (result.success && result.tickets.length > 0) {
            renderTicketsHTML(result.compra, result.tickets, container);
            successModal.classList.add("active");
        } else {
            alert("No se pudieron recuperar las boletas del servidor.");
        }
    } catch (e) {
        console.error("Error cargando boletas:", e);
        mostrarBoletasConfirmadasLocales();
    }
}

// Fallback local para renderizar boletas sin conexión a BD
function mostrarBoletasConfirmadasLocales() {
    const successModal = document.getElementById("successModal");
    const container = document.getElementById("generatedTicketsContainer");
    container.innerHTML = '';

    const compraMock = {
        id: currentCompraId,
        comprador_nombre: document.getElementById("buyerName").value.trim() || 'Juan Pérez',
        obra_titulo: currentShowTitle,
        fecha_hora: currentShowtimeData ? currentShowtimeData.fecha_hora : new Date().toISOString(),
        lugar: currentShowtimeData ? currentShowtimeData.lugar : 'Teatro Guillermo Valencia'
    };

    let ticketsMock = [];
    if (selectedSeats.length > 0) {
        selectedSeats.forEach((asiento, idx) => {
            const partes = asiento.split('_');
            ticketsMock.push({
                id: `TK-LOCAL-${idx}-${Math.floor(Math.random() * 90000 + 10000)}`,
                asiento: partes[1],
                zona: partes[0].toLowerCase(),
                qr_hash: `MOCK-HASH-${Math.random().toString(36).substring(7)}`
            });
        });
    } else {
        for (let i = 0; i < generalQty; i++) {
            ticketsMock.push({
                id: `TK-LOCAL-GEN-${i}-${Math.floor(Math.random() * 90000 + 10000)}`,
                asiento: null,
                zona: 'general',
                qr_hash: `MOCK-HASH-${Math.random().toString(36).substring(7)}`
            });
        }
    }

    renderTicketsHTML(compraMock, ticketsMock, container);
    successModal.classList.add("active");
}

// Dibujar boletas HTML y sus códigos QR en el carrusel
function renderTicketsHTML(compra, tickets, container) {
    const fecha = new Date(compra.fecha_hora).toLocaleDateString('es-ES', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });

    tickets.forEach((ticket, idx) => {
        const ticketDivId = `qr-${ticket.id}`;

        let infoAsiento = "Entrada General (No Numerada)";
        if (ticket.asiento) {
            infoAsiento = `Zona: ${ticket.zona.toUpperCase()} | Fila/Asiento: ${ticket.asiento}`;
        }

        const ticketCardHTML = `
            <div class="ticket-card" style="margin-bottom: 2rem; text-align: left;">
                <div class="ticket-header">
                    <h4 class="ticket-header-title">FESTIVAL DE TÍTERES POPAYÁN 2026</h4>
                    <p class="ticket-header-subtitle">28° Edición Internacional - Boleta de Ingreso Oficial</p>
                </div>
                <div class="ticket-body">
                    <div class="ticket-art-souvenir">
                        <img src="assets/ARTE26.webp" alt="Arte Oficial" class="ticket-art-img" loading="lazy">
                        <span class="ticket-art-label">28° FESTIVAL</span>
                    </div>
                    <div class="ticket-info">
                        <div class="ticket-info-item">
                            Obra: <strong>${compra.obra_titulo}</strong>
                        </div>
                        <div class="ticket-info-item">
                            Función: <strong>${fecha}</strong>
                        </div>
                        <div class="ticket-info-item">
                            Lugar: <strong>${compra.lugar}</strong>
                        </div>
                        <div class="ticket-info-item">
                            Ubicación: <strong>${infoAsiento}</strong>
                        </div>
                        <div class="ticket-info-item">
                            Asistente: <strong>${compra.comprador_nombre}</strong>
                        </div>
                        <div class="ticket-info-item">
                            ID Boleto: <strong style="color: var(--accent-gold); font-size:0.95rem;">${ticket.id}</strong>
                        </div>
                    </div>
                    <div class="ticket-qr-wrapper">
                        <!-- Elemento contenedor del código QR -->
                        <div class="ticket-qr-container" id="${ticketDivId}"></div>
                        <p style="font-size:0.7rem; color:var(--text-muted); text-align:center; margin-top:0.4rem;">Escanear al ingresar</p>
                    </div>
                </div>
                <div class="ticket-footer">
                    Presente este boleto digital en la entrada del teatro. Compra ref: <strong>${compra.id}</strong>
                </div>
            </div>
        `;

        container.insertAdjacentHTML('beforeend', ticketCardHTML);

        // Generar el código QR utilizando la biblioteca qrcode.js (cargada en index.html)
        setTimeout(() => {
            // El contenido del QR es la URL del validador con el hash único de la boleta
            const validatorUrl = `${window.location.origin}${window.location.pathname.replace('index.html', '')}admin.html?validate_hash=${ticket.qr_hash}`;

            new QRCode(document.getElementById(ticketDivId), {
                text: validatorUrl,
                width: 130,
                height: 130,
                colorDark: "#0d051e",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            });
        }, 100);
    });
}

function closeSuccessModal() {
    document.getElementById("successModal").classList.remove("active");
    // Recargar la página para limpiar selecciones y actualizar asientos ocupados
    window.location.reload();
}

// --- MÓDULO DE DONACIONES (INTEGRACIÓN BOLD) ---

function abrirModalDonacion() {
    // Resetear formulario
    document.getElementById("formDonacion").reset();
    setVisibilidadDonacion(false);

    // Desmarcar botones de monto rápido
    const buttons = document.querySelectorAll(".btn-monto-donacion");
    buttons.forEach(btn => btn.classList.remove("active-monto"));

    document.getElementById("donationModal").classList.add("active");
}

function cerrarModalDonacion() {
    document.getElementById("donationModal").classList.remove("active");
}

function setVisibilidadDonacion(isAnonimo) {
    donacionEsAnonima = isAnonimo;
    const optPublica = document.getElementById("optDonacionPublica");
    const optAnonima = document.getElementById("optDonacionAnonima");
    const radioNo = document.getElementById("donacionAnonimaNo");
    const radioSi = document.getElementById("donacionAnonimaSi");

    if (isAnonimo) {
        if (optPublica) optPublica.classList.remove("active");
        if (optAnonima) optAnonima.classList.add("active");
        if (radioSi) radioSi.checked = true;
    } else {
        if (optAnonima) optAnonima.classList.remove("active");
        if (optPublica) optPublica.classList.add("active");
        if (radioNo) radioNo.checked = true;
    }
}

function seleccionarMontoDonacion(amount, button) {
    document.getElementById("donacionMontoPersonalizado").value = amount;

    // Actualizar estilo activo del botón seleccionado
    const buttons = document.querySelectorAll(".btn-monto-donacion");
    buttons.forEach(btn => btn.classList.remove("active-monto"));
    button.classList.add("active-monto");
}

function closeFloatingDonationBar() {
    document.getElementById("floatingDonationBar").style.display = "none";
}

async function procesarDonacionBold(event) {
    event.preventDefault();
    const monto = parseInt(document.getElementById("donacionMontoPersonalizado").value);
    const nombre = document.getElementById("donanteNombre").value.trim();
    const email = document.getElementById("donanteEmail").value.trim();
    const phone = document.getElementById("donanteTelefono").value.trim();

    if (!monto || monto < 5000) {
        alert("El monto mínimo de donación es de $5,000 COP.");
        return;
    }

    const requestData = {
        funcion_id: 9999,
        comprador_nombre: nombre,
        comprador_email: email,
        comprador_telefono: phone,
        total: monto,
        es_anonimo: donacionEsAnonima ? 1 : 0
    };

    try {
        const response = await fetch('api/booking.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestData)
        });

        const result = await response.json();

        if (result.success) {
            cerrarModalDonacion();

            // Si la pasarela oficial BoldCheckout está disponible, usarla
            await ensureBoldCheckoutLoaded();
            if (typeof BoldCheckout !== 'undefined') {
                const checkout = new BoldCheckout({
                    apiKey: result.apiKey,
                    amount: String(result.total),
                    orderId: result.compra_id,
                    currency: 'COP',
                    integritySignature: result.signature,
                    description: "Donación voluntaria al Festival de Títeres",
                    tax: 0,
                    taxBase: 0,
                    redirectionUrl: `${window.location.origin}${window.location.pathname.replace('index.html', '')}confirmacion.html?compra_id=${result.compra_id}`
                });
                checkout.open();
            } else {
                // Fallback a simulador local
                currentCompraId = result.compra_id;
                document.getElementById("mockBuyerName").innerText = donacionEsAnonima ? 'Donante Anónimo' : nombre;
                document.getElementById("mockReference").innerText = result.compra_id;
                document.getElementById("mockTotalAmount").innerText = `$${result.total.toLocaleString('es-CO')} COP`;
                openBoldMockModal();
            }
        } else {
            alert(`Error: ${result.message}`);
        }
    } catch (error) {
        console.error("Error al procesar donación:", error);
        alert("Error de conexión con el servidor. No se pudo iniciar el checkout de donación.");
    }
}
